<template>
    <div class="site">
        <b-container fluid>
            <b-row v-if="activeSite" class="mb-4">
                <b-col cols="12">
                    <h1>
                        {{ activeSite.course.name }} <span class="lead mx-2">{{ activeSite.semester.academic_period }}</span>
                    </h1>
                    <h1>
                        <b-button
                            v-if="isUserCoordOrBetter"
                            variant="info"
                            class="mx-2"
                            @click="onNewsConfig()"
                        >
                            <b-icon-newspaper /> Configurar noticias
                        </b-button>

                        <b-button
                            v-if="isUserCoordOrBetter"
                            variant="warning"
                            class="mx-2"
                            @click="onChangeCoordinator()"
                        >
                            <b-icon-people-fill /> Cambiar Coordinador
                        </b-button>

                        <b-button
                            v-if="isUserCoordOrBetter"
                            variant="danger"
                            class="mx-2"
                            @click="onDeleteSite()"
                        >
                            <b-icon-trash-fill /> Eliminar Sitio
                        </b-button>
                    </h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="3" xl="2">
                    <SiteSidebarNav />
                </b-col>
                <b-col cols="12" lg="7" xl="8">
                    <router-view v-if="isSiteLoaded"/>
                </b-col>
                <b-col lg="2" class="d-none d-lg-block">
                    <SiteNewsDigest />
                </b-col>
            </b-row>
        </b-container>

        <!-- Change site news configuration modal -->
        <SiteNewsConfigModal />

        <!-- Change site coordinator modal -->
        <ChangeSiteCoordinatorModal />

    </div>
</template>

<script>
import ChangeSiteCoordinatorModal from './modals/ChangeSiteCoordinatorModal'
import SiteNewsConfigModal from './modals/SiteNewsConfigModal'
import SiteSidebarNav from './SiteSidebarNav'
import SiteNewsDigest from './SiteNewsDigest'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'Site',
    components: {
        SiteSidebarNav,
        SiteNewsDigest,
        SiteNewsConfigModal,
        ChangeSiteCoordinatorModal
    },
    data () {
        return {
            isSiteLoaded: false
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters({
            siteIds: 'getActiveSiteIdentifiers',
            isUserCoordOrBetter: 'isUserCoordOrBetter'
        })
    },
    watch: {
        async '$route' (to, from) {
            // Only reload site from backend API if the url parameters changed
            if (to.params.courseCode !== this.siteIds.courseCode ||
                to.params.academicPeriod !== this.siteIds.academicPeriod) {
                await this.loadCourseSiteData(to.params.courseCode, to.params.academicPeriod)
            }
        }
    },
    methods: {
        ...mapActions([
            'readCourseSiteByAcademicPeriod',
            'readPreviousSemesterCourseSites',
            'readSitesRelatedToUser',
            'resetActiveSite',
            'deleteCourseSiteById',
            'getAllCourses'
        ]),
        async loadCourseSiteData (courseCode, academicPeriod) {
            var loader = null
            this.isSiteLoaded = false
            try {
                loader = this.$loading.show()
                await this.readCourseSiteByAcademicPeriod({ courseCode: courseCode, academicPeriod: academicPeriod })
                await this.readPreviousSemesterCourseSites(courseCode)
                this.isSiteLoaded = true
            } catch (err) {
                console.log(err)
                if (err.response && err.response.status === 404) {
                    this.$root.dangerToast('El sitio de asignatura indicado no existe.', 'Sitio no encontrado')
                } else {
                    this.unknownErrorToast()
                }
                this.$router.push({ name: 'home' })
            } finally {
                loader.hide()
            }
        },
        async onDeleteSite () {
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    'Por favor confirme que desea eliminar el sitio de la materia junto con todo su contenido. Recuerde que' +
                    ' esta acción es IRREVERSIBLE.', {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Borrar Sitio',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    this.onConfirmDeleteSite()
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        onNewsConfig () {
            this.$bvModal.show('modal-news-config')
        },
        onChangeCoordinator () {
            this.$bvModal.show('modal-change-coordinator')
        },
        async onConfirmDeleteSite () {
            var loader = null
            try {
                loader = this.$loading.show()
                await this.deleteCourseSiteById(this.activeSite.id)
                await this.getAllCourses()
                await this.readSitesRelatedToUser()
                this.$root.successToast('El sitio web ha sido eliminado exitosamente.')
                this.$router.push({ name: 'home' })
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar el sitio web.')
            } finally {
                loader.hide()
            }
        }
    },
    async created () {
        await this.loadCourseSiteData(this.$route.params.courseCode, this.$route.params.academicPeriod)
    },
    destroyed () {
        this.resetActiveSite()
    }
}
</script>
